export default __webpack_public_path__ + "static/media/blank.fbcb9179.png";